<template>
  <div>
    <div
      id="success-notification-content"
      class="toastify-content hidden flex"
      v-if="toastMessage !== null"
    >
      <CheckCircleIcon class="text-theme-9" v-if="toastType === 'success'" />
      <AlertCircleIcon class="text-theme-6" v-if="toastType === 'danger'" />
      <AlertCircleIcon class="text-theme-6" v-if="toastType === 'error'" />
      <div class="ml-4 mr-4">
        <div class="font-medium">{{ toastMessage }}</div>
        <div class="text-gray-600 mt-1">
          {{ toastDescription }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useStore } from '@/store'
export default defineComponent({
  name: 'notification',
  setup() {
    const store = useStore()

    const toastType = computed(() => store.state.notification.toastType)
    const toastMessage = computed(() => store.state.notification.toastMessage)
    const toastDescription = computed(
      () => store.state.notification.toastDescription
    )
    return {
      toastType,
      toastMessage,
      toastDescription
    }
  }
})
</script>

<style scoped></style>
